import styled from 'styled-components';

export const MarketRoot = styled.div`
  background-color: var(--c-black);
  color: var(--c-white);
`;
